import {
  DOWNLOAD_REPORT_CSV,
  FREE_SUBSCRIPTION_DATA,
  GET_COURSES_REPORT,
  GET_INDIVIDUAL_COURSES_REPORT,
  GET_ALL_USER_REPORT,
  GET_ALL_FREE_CLASS_REPORT,
  GET_PRE_CLG_APPLICATION_SUBMITTED,
  TOTAL_ENTOLLMENT,
  COURSE_ENTOLLMENT,
  SALES_COURSE_PURCHASE_DATA,
  SALES_PAYMENT_PENDING,
  SALES_OVERVIEW,
  GET_CERT_APPLICATION_SUBMITTED,
  TOTAL_CERT_ENTOLLMENT,
  GET_Dl_APPLICATION_SUBMITTED,
  TOTAL_Dl_ENTOLLMENT,
  SALES_APP_PURCHASE
} from "../constants";

export const reportCsv = (payload) => ({
  type: DOWNLOAD_REPORT_CSV,
  payload: payload,
});

export const getFreeSubscriptionData = (payload) => ({
  type: FREE_SUBSCRIPTION_DATA,
  payload: payload,
});

export const getCoursesReport = (payload) => ({
  type: GET_COURSES_REPORT,
  payload: payload,
});

export const getIndividualCourseReport = (payload) => ({
  type: GET_INDIVIDUAL_COURSES_REPORT,
  payload: payload,
});

export const getAllUserReport = (payload) => ({
  type: GET_ALL_USER_REPORT,
  payload: payload,
});

export const getAllFreeClassReport = (payload) => ({
  type: GET_ALL_FREE_CLASS_REPORT,
  payload: payload,
});

export const getPreclgApplicationSubmitted = (payload) => ({
  type: GET_PRE_CLG_APPLICATION_SUBMITTED,
  payload: payload,
});

export const totalCourseEnrollmentData = (payload) => (
  {
  type: TOTAL_ENTOLLMENT,
  payload: payload,
});

export const courseEnrollMent = (payload) => ({
  type: COURSE_ENTOLLMENT,
  payload: payload,
});

export const salesCoursePurchaseData = (payload) => ({
  type: SALES_COURSE_PURCHASE_DATA,
  payload: payload,
});

export const salesPaymentPendingData = (payload) => ({
  type: SALES_PAYMENT_PENDING,
  payload: payload
})

export const salesOverviewData = (payload) =>({
  type: SALES_OVERVIEW,
  payload:payload
})

export const salesAppPurchaseData = (payload) =>({
  type: SALES_APP_PURCHASE,
  payload:payload
})

export const getCertApplicationSubmitted = (payload) => ({
  type: GET_CERT_APPLICATION_SUBMITTED,
  payload: payload,
});


export const totalCertEnrollmentData = (payload) => ({
  type: TOTAL_CERT_ENTOLLMENT,
  payload: payload,
});


export const getDlApplicationSubmitted = (payload) => ({
  type: GET_Dl_APPLICATION_SUBMITTED,
  payload: payload,
});

export const totalDlEnrollmentData = (payload) => ({
  type: TOTAL_Dl_ENTOLLMENT,
  payload: payload,
});
